import { BASE_SETTINGS, itemsData } from './game-platform-settings';

const steps = {
  zone1: [
    {
      type: 'random',
      settings: {
        maxLifeBonus: 1,
        generationChance: {
          booster: 0.1,
          enemy: 0.2,
          stuff: 0.5,
          coin: 0.1,
        },
        width: BASE_SETTINGS.width,
        height: BASE_SETTINGS.ground.position.y,
        itemsCount: 6,
        decreaseItemsCount: 4,
        offsetY: 450,
        offsetX: 75,
        initDelay: 0,
        frequency: 4000,
        enemyGroupSpeed: 30,
        stuffGroupSpeed: 30,
        lifeGroupSpeed: 20,
        diagonalSettings: {
          valueX: {
            min: -0.7,
            max: 0.7,
          },
        },
        securityHalls: [
          {
            width: {
              max: 100,
              min: 50,
            },
            height: {
              max: 100,
              min: 50,
            },
          },
        ],
      },
    },
  ],
  zone2: [
    {
      type: 'random',
      settings: {
        maxLifeBonus: 1,
        generationChance: {
          enemy: 0.3,
          stuff: 0.7,
        },
        itemsCount: 5,
        width: BASE_SETTINGS.width,
        height: BASE_SETTINGS.ground.position.y,
        offsetY: 300,
        offsetX: 75,
        initDelay: 0,
        frequency: 3000,

        enemyGroupSpeed: 30,
        stuffGroupSpeed: 30,
        lifeGroupSpeed: 20,

        diagonalSettings: {
          valueX: {
            min: -1,
            max: 1,
          },
        },
        securityHalls: [
          {
            width: {
              max: 100,
              min: 50,
            },
            height: {
              max: 100,
              min: 50,
            },
          },
        ],
      },
    },
  ],
  zone3: [
    {
      type: 'random',
      settings: {
        maxLifeBonus: 3,
        generationChance: {
          enemy: 0.4,
          stuff: 0.5,
          booster: 0.1,
        },
        itemsCount: 5,
        width: BASE_SETTINGS.width,
        height: BASE_SETTINGS.ground.position.y,
        offsetY: 300,
        offsetX: 75,
        initDelay: 0,
        frequency: 3000,

        enemyGroupSpeed: 30,
        stuffGroupSpeed: 30,
        lifeGroupSpeed: 20,

        diagonalSettings: {
          valueX: {
            min: -1,
            max: 1,
          },
        },
        securityHalls: [
          {
            width: {
              max: 100,
              min: 50,
            },
            height: {
              max: 100,
              min: 50,
            },
          },
        ],
      },
    },
  ],
  zone4: [
    {
      type: 'random',
      settings: {
        maxLifeBonus: 3,
        generationChance: {
          enemy: 0.5,
          stuff: 0.5,
        },
        itemsCount: 5,
        width: BASE_SETTINGS.width,
        height: BASE_SETTINGS.ground.position.y,
        offsetY: 300,
        offsetX: 75,
        initDelay: 0,
        frequency: 2000,

        enemyGroupSpeed: 30,
        stuffGroupSpeed: 30,
        lifeGroupSpeed: 20,

        diagonalSettings: {
          valueX: {
            min: -1,
            max: 1,
          },
        },
        securityHalls: [
          {
            width: {
              max: 150,
              min: 150,
            },
            height: {
              max: 150,
              min: 100,
            },
          },
        ],
      },
    },
  ],
  zone5: [
    {
      type: 'random',
      settings: {
        maxLifeBonus: 5,
        generationChance: {
          enemy: 0.6,
          stuff: 0.4,
        },
        itemsCount: 5,
        width: BASE_SETTINGS.width,
        height: BASE_SETTINGS.ground.position.y,
        offsetY: 200,
        offsetX: 75,
        initDelay: 0,
        frequency: 1500,

        enemyGroupSpeed: 30,
        stuffGroupSpeed: 30,
        lifeGroupSpeed: 20,

        diagonalSettings: {
          valueX: {
            min: -1,
            max: 1,
          },
        },
        securityHalls: [
          {
            width: {
              max: 750,
              min: 500,
            },
            height: {
              max: 750,
              min: 200,
            },
          },
        ],
      },
    },
  ],
  zone6: [
    {
      type: 'random',
      settings: {
        maxLifeBonus: 5,
        generationChance: { enemy: 0.3, stuff: 0.6, booster: 0.1 },
        itemsCount: 5,
        width: BASE_SETTINGS.width,
        height: BASE_SETTINGS.ground.position.y,
        offsetY: 200,
        offsetX: 1,
        initDelay: 0,
        frequency: 2500,
        enemyGroupSpeed: 30,
        stuffGroupSpeed: 30,
        lifeGroupSpeed: 20,
        diagonalSettings: { valueX: { min: -1, max: 1 } },
        securityHalls: [{ width: { max: 750, min: 500 }, height: { max: 750, min: 200 } }],
      },
    },
  ],
};

export const levels = [
  {
    id: 1,
    damage: 1,
    goodsPoint: 1,
    targetPoints: 15,
    stepsNames: ['gamePlatformLevels.levels.1.title'],
    background: {
      layers: [
        {
          name: 'bg',
        },
      ],
      bgImage: null,
    },
    enemies: itemsData.enemy,
    stuff: itemsData.stuff,
    generatorsList: [steps.zone1],
  },
  {
    id: 2,
    damage: 1,
    goodsPoint: 1,
    targetPoints: 15,
    background: {
      layers: [
        {
          name: 'bg',
        },
      ],
      bgImage: null,
    },
    enemies: itemsData.enemy,
    stuff: itemsData.stuff,
    stepsNames: ['gamePlatformLevels.levels.2.title'],
    generatorsList: [steps.zone2],
  },
  {
    id: 3,
    damage: 1,
    goodsPoint: 1,
    targetPoints: 20,
    background: {
      layers: [
        {
          name: 'bg',
        },
      ],
      bgImage: null,
    },
    stepsNames: ['gamePlatformLevels.levels.3.title'],
    enemies: itemsData.enemy,
    stuff: itemsData.stuff,
    generatorsList: [steps.zone1],
  },
  {
    id: 4,
    damage: 1,
    goodsPoint: 1,
    targetPoints: 20,
    background: {
      layers: [
        {
          name: 'bg',
        },
      ],
      bgImage: null,
    },
    enemies: itemsData.enemy,
    stuff: itemsData.stuff,
    stepsNames: ['gamePlatformLevels.levels.4.title'],
    generatorsList: [steps.zone2],
  },
  {
    id: 5,
    damage: 1,
    goodsPoint: 1,
    targetPoints: 20,
    background: {
      layers: [
        {
          name: 'bg',
        },
      ],
      bgImage: null,
    },
    enemies: itemsData.enemy,
    stuff: itemsData.stuff,
    stepsNames: ['gamePlatformLevels.levels.5.title'],
    generatorsList: [steps.zone3],
  },
  {
    id: 6,
    damage: 1,
    goodsPoint: 1,
    targetPoints: 15,
    background: {
      layers: [
        {
          name: 'bg',
        },
      ],
      bgImage: null,
    },
    enemies: itemsData.enemy,
    stuff: itemsData.stuff,
    stepsNames: ['gamePlatformLevels.levels.6.title'],
    generatorsList: [steps.zone2],
  },
  {
    id: 7,
    damage: 1,
    goodsPoint: 1,
    targetPoints: 30,
    background: {
      layers: [
        {
          name: 'bg',
        },
      ],
      bgImage: null,
    },
    enemies: itemsData.enemy,
    stuff: itemsData.stuff,
    stepsTime: [12, 12],
    stepsNames: ['gamePlatformLevels.levels.7.title', 'gamePlatformLevels.levels.7.title2'],
    generatorsList: [steps.zone1, steps.zone2],
  },
  {
    id: 8,
    damage: 1,
    goodsPoint: 1,
    targetPoints: 30,
    background: {
      layers: [
        {
          name: 'bg',
        },
      ],
      bgImage: null,
    },
    enemies: itemsData.enemy,
    stuff: itemsData.stuff,
    stepsTime: [12, 12],
    stepsNames: ['gamePlatformLevels.levels.8.title', 'gamePlatformLevels.levels.8.title2'],
    generatorsList: [steps.zone2, steps.zone3],
  },
  {
    id: 9,
    damage: 1,
    goodsPoint: 1,
    targetPoints: 30,
    background: {
      layers: [
        {
          name: 'bg',
        },
      ],
      bgImage: null,
    },
    enemies: itemsData.enemy,
    stuff: itemsData.stuff,
    stepsTime: [12, 12],
    stepsNames: ['gamePlatformLevels.levels.9.title', 'gamePlatformLevels.levels.9.title2'],
    generatorsList: [steps.zone1, steps.zone3],
  },
  {
    id: 10,
    damage: 1,
    goodsPoint: 1,
    targetPoints: 20,
    background: {
      layers: [
        {
          name: 'bg',
        },
      ],
      bgImage: null,
    },
    enemies: itemsData.enemy,
    stuff: itemsData.stuff,
    stepsNames: ['gamePlatformLevels.levels.10.title'],
    generatorsList: [steps.zone1],
  },
  {
    id: 11,
    damage: 1,
    goodsPoint: 1,
    targetPoints: 25,
    background: {
      layers: [
        {
          name: 'bg',
        },
      ],
      bgImage: null,
    },
    enemies: itemsData.enemy,
    stuff: itemsData.stuff,
    stepsNames: ['gamePlatformLevels.levels.11.title', 'gamePlatformLevels.levels.11.title2'],
    stepsTime: [12, 12],
    generatorsList: [steps.zone2, steps.zone3],
  },
  {
    id: 12,
    damage: 1,
    goodsPoint: 1,
    targetPoints: 25,
    background: {
      layers: [
        {
          name: 'bg',
        },
      ],
      bgImage: null,
    },
    enemies: itemsData.enemy,
    stuff: itemsData.stuff,
    stepsNames: ['gamePlatformLevels.levels.12.title', 'gamePlatformLevels.levels.12.title2'],
    stepsTime: [12, 12],
    generatorsList: [steps.zone2, steps.zone1],
  },
  {
    id: 13,
    damage: 1,
    goodsPoint: 1,
    targetPoints: 30,
    background: {
      layers: [
        {
          name: 'bg',
        },
      ],
      bgImage: null,
    },
    enemies: itemsData.enemy,
    stuff: itemsData.stuff,
    stepsNames: ['gamePlatformLevels.levels.13.title', 'gamePlatformLevels.levels.13.title2'],
    stepsTime: [12, 12],
    generatorsList: [steps.zone1, steps.zone3],
  },
  {
    id: 14,
    damage: 1,
    goodsPoint: 1,
    targetPoints: 30,
    background: {
      layers: [
        {
          name: 'bg',
        },
      ],
      bgImage: null,
    },
    enemies: itemsData.enemy,
    stuff: itemsData.stuff,
    stepsNames: ['gamePlatformLevels.levels.14.title', 'gamePlatformLevels.levels.14.title2'],
    stepsTime: [12, 12],
    generatorsList: [steps.zone2, steps.zone3],
  },
  {
    id: 15,
    damage: 1,
    goodsPoint: 1,
    targetPoints: 30,
    background: {
      layers: [
        {
          name: 'bg',
        },
      ],
      bgImage: null,
    },
    enemies: itemsData.enemy,
    stuff: itemsData.stuff,
    stepsNames: ['gamePlatformLevels.levels.15.title', 'gamePlatformLevels.levels.15.title2'],
    stepsTime: [12, 12],
    generatorsList: [steps.zone3, steps.zone1],
  },
  {
    id: 16,
    damage: 1,
    goodsPoint: 1,
    targetPoints: 30,
    background: {
      layers: [
        {
          name: 'bg',
        },
      ],
      bgImage: null,
    },
    enemies: itemsData.enemy,
    stuff: itemsData.stuff,
    stepsNames: ['gamePlatformLevels.levels.16.title', 'gamePlatformLevels.levels.16.title2'],
    generatorsList: [steps.zone1, steps.zone4],
  },
  {
    id: 17,
    damage: 1,
    goodsPoint: 1,
    targetPoints: 30,
    background: {
      layers: [
        {
          name: 'bg',
        },
      ],
      bgImage: null,
    },
    enemies: itemsData.enemy,
    stuff: itemsData.stuff,
    stepsNames: [
      'gamePlatformLevels.levels.17.title',
      'gamePlatformLevels.levels.17.title2',
      'gamePlatformLevels.levels.17.title3',
    ],
    stepsTime: [12, 12, 12],
    generatorsList: [steps.zone2, steps.zone3, steps.zone4],
  },
  {
    id: 18,
    damage: 1,
    goodsPoint: 1,
    targetPoints: 25,
    background: {
      layers: [
        {
          name: 'bg',
        },
      ],
      bgImage: null,
    },
    enemies: itemsData.enemy,
    stuff: itemsData.stuff,
    stepsNames: [
      'gamePlatformLevels.levels.18.title',
      'gamePlatformLevels.levels.18.title2',
      'gamePlatformLevels.levels.18.title3',
    ],
    stepsTime: [12, 12, 12],
    generatorsList: [steps.zone3, steps.zone1, steps.zone4],
  },
  {
    id: 19,
    damage: 1,
    goodsPoint: 1,
    targetPoints: 25,
    background: {
      layers: [
        {
          name: 'bg',
        },
      ],
      bgImage: null,
    },
    enemies: itemsData.enemy,
    stuff: itemsData.stuff,
    stepsNames: [
      'gamePlatformLevels.levels.19.title',
      'gamePlatformLevels.levels.19.title2',
      'gamePlatformLevels.levels.19.title3',
    ],
    stepsTime: [12, 12, 12],
    generatorsList: [steps.zone2, steps.zone3, steps.zone1],
  },
  {
    id: 20,
    damage: 1,
    goodsPoint: 1,
    targetPoints: 30,
    background: {
      layers: [
        {
          name: 'bg',
        },
      ],
      bgImage: null,
    },
    enemies: itemsData.enemy,
    stuff: itemsData.stuff,
    stepsNames: [
      'gamePlatformLevels.levels.20.title',
      'gamePlatformLevels.levels.20.title2',
      'gamePlatformLevels.levels.20.title3',
    ],
    stepsTime: [12, 12, 12],
    generatorsList: [steps.zone2, steps.zone4, steps.zone1],
  },
  {
    id: 21,
    damage: 1,
    goodsPoint: 1,
    targetPoints: 30,
    background: {
      layers: [
        {
          name: 'bg',
        },
      ],
      bgImage: null,
    },
    enemies: itemsData.enemy,
    stuff: itemsData.stuff,
    stepsNames: [
      'gamePlatformLevels.levels.21.title',
      'gamePlatformLevels.levels.21.title2',
      'gamePlatformLevels.levels.21.title3',
    ],
    stepsTime: [12, 12, 12],
    generatorsList: [steps.zone3, steps.zone1, steps.zone2],
  },
  {
    id: 22,
    damage: 1,
    goodsPoint: 1,
    targetPoints: 30,
    background: {
      layers: [
        {
          name: 'bg',
        },
      ],
      bgImage: null,
    },
    enemies: itemsData.enemy,
    stuff: itemsData.stuff,
    stepsNames: [
      'gamePlatformLevels.levels.22.title',
      'gamePlatformLevels.levels.22.title2',
      'gamePlatformLevels.levels.22.title3',
    ],
    stepsTime: [12, 12, 12],
    generatorsList: [steps.zone1, steps.zone4, steps.zone2],
  },
  {
    id: 23,
    damage: 1,
    goodsPoint: 1,
    targetPoints: 30,
    background: {
      layers: [
        {
          name: 'bg',
        },
      ],
      bgImage: null,
    },
    enemies: itemsData.enemy,
    stuff: itemsData.stuff,
    stepsNames: ['gamePlatformLevels.levels.23.title'],
    generatorsList: [steps.zone2],
  },
  {
    id: 24,
    damage: 1,
    goodsPoint: 1,
    targetPoints: 30,
    background: {
      layers: [
        {
          name: 'bg',
        },
      ],
      bgImage: null,
    },
    enemies: itemsData.enemy,
    stuff: itemsData.stuff,
    stepsNames: ['gamePlatformLevels.levels.24.title', 'gamePlatformLevels.levels.24.title2'],
    stepsTime: [12, 12, 12],
    generatorsList: [steps.zone2, steps.zone3],
  },
  {
    id: 25,
    damage: 1,
    goodsPoint: 1,
    targetPoints: 30,
    background: {
      layers: [
        {
          name: 'bg',
        },
      ],
      bgImage: null,
    },
    enemies: itemsData.enemy,
    stuff: itemsData.stuff,
    stepsNames: ['gamePlatformLevels.levels.25.title', 'gamePlatformLevels.levels.25.title2'],
    stepsTime: [12, 12, 12],
    generatorsList: [steps.zone3, steps.zone4],
  },
  {
    id: 26,
    damage: 1,
    goodsPoint: 1,
    targetPoints: 30,
    background: {
      layers: [
        {
          name: 'bg',
        },
      ],
      bgImage: null,
    },
    enemies: itemsData.enemy,
    stuff: itemsData.stuff,
    stepsNames: [
      'gamePlatformLevels.levels.26.title',
      'gamePlatformLevels.levels.26.title2',
      'gamePlatformLevels.levels.26.title3',
      'gamePlatformLevels.levels.26.title4',
    ],
    stepsTime: [12, 12, 12, 12],
    generatorsList: [steps.zone1, steps.zone4, steps.zone2, steps.zone3],
  },
  {
    id: 27,
    damage: 1,
    goodsPoint: 1,
    targetPoints: 20,
    background: {
      layers: [
        {
          name: 'bg',
        },
      ],
      bgImage: null,
    },
    enemies: itemsData.enemy,
    stuff: itemsData.stuff,
    stepsNames: ['gamePlatformLevels.levels.27.title'],
    generatorsList: [steps.zone3],
  },
  {
    id: 28,
    damage: 1,
    goodsPoint: 1,
    targetPoints: 30,
    background: {
      layers: [
        {
          name: 'bg',
        },
      ],
      bgImage: null,
    },
    enemies: itemsData.enemy,
    stuff: itemsData.stuff,
    stepsNames: ['gamePlatformLevels.levels.28.title', 'gamePlatformLevels.levels.28.title2'],
    stepsTime: [12, 12, 12],
    generatorsList: [steps.zone2, steps.zone1],
  },
  {
    id: 29,
    damage: 1,
    goodsPoint: 1,
    targetPoints: 10,
    background: {
      layers: [
        {
          name: 'bg',
        },
      ],
      bgImage: null,
    },
    enemies: itemsData.enemy,
    stuff: itemsData.stuff,
    stepsNames: ['gamePlatformLevels.levels.29.title'],
    generatorsList: [steps.zone4],
  },
  {
    id: 30,
    damage: 1,
    goodsPoint: 1,
    targetPoints: 30,
    background: {
      layers: [
        {
          name: 'bg',
        },
      ],
      bgImage: null,
    },
    enemies: itemsData.enemy,
    stuff: itemsData.stuff,
    stepsNames: ['gamePlatformLevels.levels.30.title', 'gamePlatformLevels.levels.30.title2'],
    stepsTime: [12, 12],
    generatorsList: [steps.zone3, steps.zone1],
  },
];

export const infinityLevel = {
  id: 1,
  damage: 1,
  goodsPoint: 1,
  targetPoints: Infinity,
  stepsNames: ['gamePlatformLevels.levels.infinity.title'],
  background: { layers: [{ name: 'bg' }], bgImage: null },
  enemies: itemsData.enemy,
  stuff: itemsData.stuff,
  booster: itemsData.booster,
  coin: itemsData.coin,
  generatorsList: [steps.zone1],
};
